module.exports = __webpack_public_path__ + "static/media/Niveau_elN14_4_762591.405a070c.png";